export const EMAIL_CAPTURE_I18N = '@mc/email-capture'
export const AUTH_STARTED_COOKIE_KEY = 'checkout_auth_started'
export const CHECKOUT_GOOGLE_AUTH_COOKIE_KEY = 'checkout_google_auth'
